// MaskedTextControlView
import eventBus         from 'EventBus';
import BaseControlView from 'BaseControlView';
import constants        from "Constants";
import template from 'advanced-inputs/control_masked_text.ejs';
import themeService     from 'ThemeService.js';

//=====================================================================
//
// An instance of this view represents a masked text input control.
//
// Maty Rocha, January, 11 2016
//
//=====================================================================
class MaskedTextControlView extends BaseControlView  {

    initialize( opts ) {
        super.initialize( opts );

        this.template = template;
        this.tagName = 'div';
        this.family = constants.CONTROL_ADVANCED_INPUTS;
        this.icon = 'pf-mask-text-input';
        this.events = {};

        this.listenTo( eventBus, 'InputThemeChange', this.themeChangeRender );
        this.listenTo( this.model, 'change', this.reprintMask );
        this.listenTo( eventBus, constants.EV_UPDATE_MARGIN_FROM_FORM, this.mobileMarginChangeRender);

        return this;
    }

    // Neighbor aligner uses this polymorphic property, looking for
    // value 'BaseStaticTextControl'
    get kind() {
        return 'BaseStaticTextControl';
    }

    reprintMask() {
        let _fontSize = this.model.get("fontSize");
        let fontSize = 12;
        if (_fontSize && _fontSize.indexOf && _fontSize.indexOf('~') === 0){
            fontSize = themeService.resolve(fontSize);
        }

        fontSize = Number(fontSize);
        let multiplyBy = 1.4;
        let widthPercentage = 0.9;

        if (Number.isNaN(fontSize) || fontSize === 10) {
            fontSize = 10;
            this.model.set("height", 16,{silent:true});
            widthPercentage = 1;
        }

        const itemWidth = Math.floor(fontSize * widthPercentage);

        this.model.set('widthItem', itemWidth,{silent:true});
        this.model.set('heightItem', Math.floor(fontSize * multiplyBy),{silent:true});       

        //PF-6284 Calculate the width based on the placeholders and not the text so the width correspond with the designer.
        const maskedWidth = this.model.get("mask").split('').length * (itemWidth + 4); //+4 to account for the 2px margin of each placeholder.
        if(maskedWidth){
            this.model.set("width", maskedWidth, {silent:true});
        }
    }
}

export default MaskedTextControlView;
